import { Icon } from '@scale/scaleui';
import { useChatLayoutStore } from '../ThreadedInteraction/hooks/useChatLayoutStore';
import { useFieldRubricStore } from '../ThreadedInteraction/hooks/useFieldRubricStore';
import { createChatTaskEventObj } from '@scale/shared/chat/events';
import { ChatTaskEventType } from '@scale/shared/types/chat/events';
import { logChatTaskEvent } from '../ThreadedInteraction/events';
import { useContext } from 'react';
import { ChatTaskContext } from '../ThreadedInteraction/contexts/ChatTaskContext';

type TProps = {
  rubric: string;
  onClick?: () => void;
};

const OpenRubricButton = ({ rubric, onClick }: TProps) => {
  const taskContext = useContext(ChatTaskContext);
  const { setIsDrawerOpen } = useChatLayoutStore();
  const { setRubric } = useFieldRubricStore();

  return (
    <Icon
      className="rounded"
      variant="neutral"
      icon="table"
      hasBackground
      tooltip="See field's rubric"
      onClick={async () => {
        const event = createChatTaskEventObj(
          ChatTaskEventType.OpenRubric,
          undefined,
          taskContext.projectId,
          taskContext.taskId,
        );
        setRubric(rubric || '');
        setIsDrawerOpen(true);
        onClick?.();
        try {
          await logChatTaskEvent(event);
        } catch (err) {
          // fail silently
        }
      }}
      size="sm"
    />
  );
};

export default OpenRubricButton;
